<template>
    <!--顶部导航-->
    <vhead></vhead>
     <vheadnav></vheadnav>
    <!--右侧-->
    <div id="app">
      <Router></Router>
    </div>
    <vfooter></vfooter>
</template>

<script>
  import vhead from '../common/Head';
  import vheadnav from '../common/Header-nav.vue';
  import vfooter from '../common/Foot';
  import Router from './Router/router.js';
  export default{
    components: {
      vhead,
      vfooter,
      Router,
      vheadnav
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Case.vue?6e00254b